import UploadCsvClientsForm from './UploadCsvClientsForm';

export default UploadCsvClientsForm;


// WEBPACK FOOTER //
// ./src/features/score-card/components/upload-csv-clients-form/index.js